import { App } from 'vue';
import vLoadingDirective from './src/loading.ts';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vLoadingDirective as vLoading };
